var $ = require('jQuery');
var Vue = require('vue');
var Leaderboard = require('./Leaderboard.vue').default;
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
const store = require('@/lib/store').default;

module.exports = function() {
  const leaderboard = new Vue({
    el: '#leaderboard',
    components: {
      'leaderboard': Leaderboard
    },
    store
  });

  $(document).one('pjax:end', () => {
    leaderboard.$destroy();
  });

  new IndexView();
  new Columnator();
};
